import React, { useState } from 'react';

import { formatToFixedMoneyWithLocale } from 'Helpers/formatService';
import { generateKey } from 'Helpers/misc';

import MinusCircleIcon from 'Assets/icons/minus.svg';
import PlusCircleIcon from 'Assets/icons/plus.svg';

export default function KeyMetricsWorkforceSummary(props) {
    const [show, setShow] = useState(true);

    return (
        <div className="tw-border-0 tw-rounded-lg tw-bg-white tw-shadow tw-h-full">
            <div className="tw-p-2.5 tw-flex tw-flex-col tw-gap-3">
                <div className="tw-flex tw-flex-row tw-justify-between tw-pb-3">
                    <div>
                        <h3 className="tw-text-blue tw-text-2xl tw-font-semibold tw-pb-1">{$t('Workforce Summary')}</h3>
                    </div>
                    {!show && (
                        <div className={'tw-cursor-pointer'} onClick={() => setShow(true)}>
                            <div className={'tw-h-10 tw-w-10 tw-bg-blue tw-flex tw-justify-center tw-items-center tw-rounded-full'}>
                                <PlusCircleIcon className={'tw-h-3.5 tw-w-3.5 tw-text-white'} />
                            </div>
                        </div>
                    )}
                    {!!show && (
                        <div className={'tw-cursor-pointer'} onClick={() => setShow(false)}>
                            <div className={'tw-h-10 tw-w-10 tw-bg-blue tw-flex tw-justify-center tw-items-center tw-rounded-full'}>
                                <MinusCircleIcon className={'tw-h-3.5 tw-w-3.5 tw-text-white'} />
                            </div>
                        </div>
                    )}
                </div>

                {!!show && (
                    <div className="tw-rounded-lg tw-border-2 tw-border-gray-200">
                        <div className="tw-p-2.5">
                            <ul className={'tw-flex tw-flex-col tw-gap-1 tw-text-sm'}>
                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('Total Headcount')}</span>
                                    <span className={' tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>{props.summaryWorkforce.positions_count}</span>
                                </li>
                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                    <span className={'tw-w-col tw-font-extrabold tw-text-blue'}>{$t('Top 3 departments').toUpperCase()}</span>
                                </li>
                                {props.summaryWorkforce?.positions_by_departments_count?.map((row) => {
                                    return (
                                        <li key={generateKey()} className={'tw-flex max-lg:tw-flex-col'}>
                                            <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{row.department_name}</span>
                                            <span className={' tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>{row.count}</span>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                )}

                {!!show && (
                    <div className="tw-flex tw-flex-row max-lg:tw-flex-col tw-gap-3">
                        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-w-6/12 max-lg:tw-w-full">
                            <div className="tw-p-2.5">
                                <ul className={'tw-flex tw-flex-col tw-gap-1 tw-text-sm'}>
                                    <li className={'tw-flex'}>
                                        <span className={'tw-w-col tw-font-extrabold tw-text-blue'}>{$t('Top 3 total').toUpperCase()}</span>
                                    </li>
                                    {props.summaryWorkforce?.top_3_departments_by_total_workforce?.map((row) => {
                                        return (
                                            <li key={generateKey()} className={'tw-flex max-lg:tw-flex-col'}>
                                                <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{row.department_name}</span>
                                                <span className={' tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                                    {formatToFixedMoneyWithLocale(row.total)}
                                                </span>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>

                        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-w-6/12 max-lg:tw-w-full">
                            <div className="tw-p-2.5">
                                <ul className={'tw-flex tw-flex-col tw-gap-1 tw-text-sm'}>
                                    <li className={'tw-flex max-lg:tw-flex-col'}>
                                        <span className={'tw-w-col tw-font-extrabold tw-text-blue'}>{$t('Top 3 bottom').toUpperCase()}</span>
                                    </li>
                                    {props.summaryWorkforce?.bottom_3_departments_by_total_workforce?.map((row) => {
                                        return (
                                            <li key={generateKey()} className={'tw-flex max-lg:tw-flex-col'}>
                                                <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{row.department_name}</span>
                                                <span className={' tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                                    {formatToFixedMoneyWithLocale(row.total)}
                                                </span>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
